export enum NavigateTo{
    Login = "/login",
    REGISTRATION = "/registration",
    ADD_MANUALLY="/add-manually",
    DASHBOARD="/dashboard",
    DASHBOARD_ROUTER ="/dashboard-router"
}